// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const logo = {
  logo: 'https://cdn.myalex.com/tailor/production/v11/placeholder-industries/67095c53-14aa-4c1a-ab83-06682c70b09f/3/0.png',
};
